export class Formats {
  public static readonly BACKEND_DATE = 'YYYY-MM-DDTHH:mm:ss';
  public static readonly FRONTEND_DATE = 'MMM DD, YYYY';
  public static readonly BACKEND_TIME = 'HH:mm';
  public static readonly FRONTEND_TIME = 'h:mm a';
  public static readonly FRONTEND_TIME_ZONE = 'h:mm a (Z)';
}
